<template>
    <form class="question" ref="form">
        <div class="question__image" v-if="getImgUrl(question.image_url)" v-bind:style="{ backgroundImage: 'url(' + getImgUrl(question.image_url) + ')' }"></div>

        <div class="question__title">
            <div class="question__title-content">
                <img src="@/images/cloud-1.svg" class="question__cloud-1">

                {{ question.title_text }}

                <img src="@/images/cloud-2.svg" class="question__cloud-2">
            </div>
        </div>

        <div class="question__content">
            <div class="question__content-body">
                <p v-if="question.intro_text" class="question__intro">{{ question.intro_text }}</p>

                <template v-if="question.type=='optionset'">
                    <OptionsetField ref="answer" :question=question></OptionsetField>
                </template>

                <template v-else-if="question.type=='text'">
                    <TextareaField ref="answer" :label=question.label_text :placeholder="question.placeholder_text"></TextareaField>
                </template>

                <template v-if="is_final">
                    <InputField ref="email" :label="'Finally, your email address:'" type="email"></InputField>

                    <SelectField ref="country" :label="'Where do you live?'" :options="countryOptions" default-text="- Select a country -" v-model="country"></SelectField>

                    <SelectField ref="region" :options="regionOptions[country]" default-text="- Select a region -" v-model="region" v-if="country && country != 'Other'"></SelectField>

                    <SelectField ref="source" :label="'How did you hear about this promotion?'" :options="sourceOptions" default-text="- Select an option -" v-model="source"></SelectField>
                </template>

                <div class="question__actions">
                    <template v-if=is_final>
                        <button class="button button--blue question__action" name="finishsubscribe" @click.prevent="handleSubmit('finishsubscribe')">
                            Reveal my result and sign me up to the Friends of Mackie’s email newsletter
                        </button>

                        <button class="button button--blue question__action" name="finish" @click.prevent="handleSubmit('finish')">
                            Reveal my result and don't sign me up to the Friends of Mackie’s email newsletter
                        </button>
                    </template>

                    <button v-if=!is_final class="button button--blue question__action" name="next" @click.prevent="handleSubmit('next')">
                        NEXT QUESTION
                    </button>
                </div>
            </div>
        </div>

        <div class="question__hills"></div>
    </form>
</template>

<script>
import OptionsetField from "@/components/fields/Optionset";
import TextareaField from "@/components/fields/Textarea";
import InputField from "@/components/fields/Input";
import SelectField from "@/components/fields/SelectField";

export default {
    name: "Question",
    components: {
        OptionsetField,
        TextareaField,
        InputField,
        SelectField

    },
    props: {
        question: Object,
        quiz_data: Object,
        is_final: Boolean
    },
    data() {
        return {
            selection: null,
            country: '',
            region: '',
            source: '',
            countryOptions: [
                'Scotland',
                'England',
                'Wales',
                'Northern Ireland',
                'Other'
            ],
            sourceOptions: [
                'Social Media',
                'On the Mackie\'s ice cream tub',
                'Friends of Mackie\'s e-mail',
                'Word of mouth',
                'Other'
            ],
            regionOptions: {
                'Scotland': [
                    'Aberdeen',
                    'Aberdeenshire',
                    'Angus',
                    'Argyll and Bute',
                    'Clackmannanshire',
                    'Dumfries and Galloway',
                    'Dundee',
                    'East Ayrshire',
                    'East Dumbartonshire',
                    'East Lothian',
                    'East Renfrewshire',
                    'Edinburgh',
                    'Falkirk',
                    'Fife',
                    'Glasgow',
                    'Highland',
                    'Inverclyde',
                    'Midlothian',
                    'Moray',
                    'North Ayrshire',
                    'North Lanarkshire',
                    'Orkney',
                    'Perth and Kinross',
                    'Renfrewshire',
                    'Scottish Borders',
                    'Shetland Isles',
                    'South Ayrshire',
                    'South Lanarkshire',
                    'Stirlingshire',
                    'West Dunbartonshire',
                    'West Lothian',
                    'Western Isles',
                ],
                'England': [
                    'Bedfordshire',
                    'Berkshire',
                    'Bristol',
                    'Buckinghamshire',
                    'Cambridgeshire',
                    'Cheshire',
                    'Cornwall',
                    'Cumbria',
                    'Derbyshire',
                    'Devon',
                    'Dorset',
                    'Durham',
                    'East Riding of Yorkshire',
                    'East Sussex',
                    'Essex',
                    'Gloucestershire',
                    'Greater Manchester',
                    'Hampshire',
                    'Hereford and Worcester',
                    'Hertfordshire',
                    'Isle of Man',
                    'Isle of Wight',
                    'Kent',
                    'Lancashire',
                    'Leicestershire',
                    'Lincolnshire',
                    'London',
                    'Merseyside',
                    'Middlesex',
                    'Norfolk',
                    'North Yorkshire',
                    'Northamptonshire',
                    'Northumberland',
                    'Nottinghamshire',
                    'Oxfordshire',
                    'Rutland',
                    'Shropshire',
                    'Somerset',
                    'South Yorkshire',
                    'Staffordshire',
                    'Suffolk',
                    'Surrey',
                    'Tyne and Wear',
                    'Warwickshire',
                    'West Midlands',
                    'West Sussex',
                    'West Yorkshire',
                    'Wiltshire',
                ],
                'Wales': [
                    'Anglesey/Sir Fon',
                    'Blaenau Gwent',
                    'Bridgend',
                    'Caerphilly',
                    'Cardiff',
                    'Carmarthenshire',
                    'Ceredigion',
                    'Conwy',
                    'Denbighshire',
                    'Flintshire',
                    'Glamorgan',
                    'Gwynedd',
                    'Merthyr Tydfil',
                    'Monmouthshire',
                    'Neath Port Talbot',
                    'Newport',
                    'Newport City',
                    'Pembrokeshire',
                    'Powys',
                    'Rhondda Cynon Taff',
                    'Swansea',
                    'Torfaen',
                    'Wrexham',
                ],
                'Northern Ireland': [
                    'County Antrim',
                    'County Armagh',
                    'County Down',
                    'County Fermanagh',
                    'County Londonderry',
                    'County Tyrone',
                ]
            }
        }
    },
    methods: {
        handleSubmit(action) {
            if(this.$refs.form.checkValidity()) {
                this.$emit('handle-step-submit', action, this);
            } else {
                this.$refs.form.reportValidity();
            }
        }
    }
}
</script>

<style scoped lang="stylus">

.question {
    display: flex;
    flex: 1 0 100%;
    flex-direction: column;

    &__image {
        height: 150px;
        background-size: cover;
        background-position: 50% 50%;
        background-repeat no-repeat;
        object-fit contain;
    }

    &__content {
        display: flex;
        flex-direction: column;
        width: 100%;
        flex-grow: 1;
        padding: 1.3em;
        box-sizing border-box;
    }

    &__title {
        background: brand-blue;
        color: brand-yellow;
        font-size: 1.2em;
        font-weight: 700;
        margin: 0;
        flex-shrink: 0;
        flex-basis: auto;
        overflow: hidden;
    }

    &__title-content {
        padding: 2em;
        position: relative;
    }

    &__cloud-1 {
        position: absolute;
        top: 0;
        left: -1em;
        bottom: 0;
        max-width: 40%;
        pointer-events none;
        user-select none;
        height: 137%;
    }

    &__cloud-2 {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        max-width: 40%;
        pointer-events none;
        user-select none;
        height: 137%;
    }

    &__content-body {
        flex-shrink: 0;
        flex-basis: auto;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    &__intro {
        margin: 0 auto 1.5em;
    }

    &__actions {
        display: flex;
        flex-direction: column;
        align-items center;
        gap: 1em;
    }

    &__action {
        box-shadow: 0 0.3em 1em rgba(0, 0, 0, 0.2);
        max-width: 24em;
        font-size: 1.15em;
    }

    &__hills {
        background: url('../images/hills.svg') no-repeat;
        background-position: 50% 0;
        background-size: cover;
        height: 20%;
        max-height: 400px;
        min-height: 250px;
        width: 100%;
    }
}

@media (min-width: 1000px) {
    .question {
        overflow: hidden;

        &__title {
            font-size: 1.5em;
            padding-left: 30%;
        }

        &__title-content {
            padding: 3em 3em 2.7em;
        }

        &__intro {
            margin-bottom: 2.5em;
        }

        &__image {
            height: auto;
            width: 30%;
            position: fixed;
            top: 120px;
            left: 0;
            bottom: 0;
            right: auto;
            background-position: 50% 50%;
            z-index: 10;
            mask-image: url('../images/curve-mask.svg');
            mask-position: 100% 50%;
            mask-repeat: no-repeat;
            mask-size: cover;
        }

        &__content {
            margin-left: 30%;
            width: auto;
            padding: 2.5em 3em;
        }

        &__content-body {
            max-width: 56em;
            margin: 0 auto;
        }

        &__options {
            flex-direction: column;
        }

        &__hills {
            margin-left: 15%;
            width: 85%;
        }
    }
}

@media (min-width: 1600px) {
    .question {
        &__title {
            font-size: 1.8em;
        }
    }
}
</style>